// extracted by mini-css-extract-plugin
export default {"protocols":"protocols_protocols__GWFxR","protocolsMainContainer":"protocols_protocolsMainContainer__y8FSq","protocolsContainer":"protocols_protocolsContainer__uXdI0"};